module.exports = __webpack_public_path__ + "f19aca0991d596426151cdeb12dee252.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Rist/content/images/news/QT_Sydney_Room_869x278.jpg
// module id = 868
// module chunks = 0